import { GruppeTier } from '../../gruppe-tier/classes/gruppe-tier';

export class GruppeTierbemerkung {
    gruppe: string;
    gruppeId: number;
    kunde: string;
    zusatz: string;
    tiere: GruppeTier[] = [];
}

export class KundenBemerkung {
    kb_id: number;
    kunde_id: number;
    bemerkung: string;
    tierarzt: number;
    vorname: string;
    nachname: string;
    erstellt: Date;
}
